export default "__VITE_ASSET__Bk25glZT__"